import Chip from '@mui/material/Chip'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'
import { alpha, useTheme } from '@mui/material/styles'
import React from 'react'

interface Props {
  summary: {
    customers: number
    subscriptions: number
    transactions: number
    visible: number
  }
}

export const SubscriptionsSummary: React.FC<Props> = ({ summary }) => {
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const labels = isSmallScreen
    ? {
        subscriptions: `${summary.subscriptions} subs`,
        customers: `${summary.customers} cust`,
        transactions: `${summary.transactions} txns`,
        visible: `${summary.visible} vis`,
      }
    : {
        subscriptions: `${summary.subscriptions} subscriptions`,
        customers: `${summary.customers} customers`,
        transactions: `${summary.transactions} transactions`,
        visible: `${summary.visible} visible`,
      }

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      justifyContent="space-between"
      alignItems={{ xs: 'flex-start', sm: 'center' }}
      spacing={{ xs: 0.5, sm: 0.75 }}
    >
      <Box>
        <Typography
          variant="h6"
          sx={{ fontSize: { xs: '1rem', sm: '1.1rem' }, lineHeight: 1.2 }}
        >
          Subscriptions
        </Typography>
        <Typography
          variant="body2"
          color={alpha(theme.palette.common.white, 0.78)}
          sx={{
            fontSize: { xs: '0.74rem', sm: '0.78rem' },
            lineHeight: 1.3,
            maxWidth: 620,
          }}
        >
          Active recurring rentals with transaction history grouped beneath each
          subscription.
        </Typography>
      </Box>
      <Stack
        direction="row"
        spacing={0.5}
        flexWrap="wrap"
        justifyContent={{ xs: 'flex-start', sm: 'flex-end' }}
      >
        <Chip
          label={labels.subscriptions}
          size="small"
          sx={{
            height: 22,
            bgcolor: alpha(theme.palette.common.white, 0.18),
            color: theme.palette.common.white,
            '& .MuiChip-label': { px: 0.9, fontWeight: 700, fontSize: '0.68rem' },
          }}
        />
        <Chip
          label={labels.customers}
          size="small"
          sx={{
            height: 22,
            bgcolor: alpha(theme.palette.common.white, 0.18),
            color: theme.palette.common.white,
            '& .MuiChip-label': { px: 0.9, fontWeight: 700, fontSize: '0.68rem' },
          }}
        />
        <Chip
          label={labels.transactions}
          size="small"
          sx={{
            height: 22,
            bgcolor: alpha(theme.palette.common.white, 0.18),
            color: theme.palette.common.white,
            '& .MuiChip-label': { px: 0.9, fontWeight: 700, fontSize: '0.68rem' },
          }}
        />
        <Chip
          label={labels.visible}
          size="small"
          sx={{
            height: 22,
            bgcolor: alpha(theme.palette.common.white, 0.28),
            color: theme.palette.common.white,
            '& .MuiChip-label': { px: 0.9, fontWeight: 700, fontSize: '0.68rem' },
          }}
        />
      </Stack>
    </Stack>
  )
}
